export default "__VITE_ASSET__b56a84fb__"